<template>
  <div class="page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(route, index) in breadcrumbItems"
        :key="index"
      >
        <!-- 判断面包屑是否有path属性，如果有则显示router-link标签 -->
        <router-link v-if="route.path" :to="route.path">
          <i :class="route.icon"></i>
          <span>{{ route.title }}</span>
        </router-link>
        <!-- 如果没有path属性则不跳转 -->
        <template v-else>
          <i :class="route.icon"></i>
          <span>{{ route.title }}</span>
        </template>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-right: 20px">
      <el-badge
        :value="total"
        class="item"
        :max="99"
        style="margin-right: 20px"
      >
        <el-button size="small" @click="noticeClick">通 知</el-button>
      </el-badge>
      <el-button type="primary" size="mini" @click="quit">退 出</el-button>
    </div>
    <noticeList :dialogVisible="noticeShow" @close="close"></noticeList>
  </div>
</template>

<script>
import noticeList from "./noticeList.vue";
export default {
  components: {
    noticeList,
  },
  data() {
    return {
      breadcrumbItems: [],
      page: 0, // 请求页码
      limit: 20, // 一页多少个
      total: 0,
      noticeShow: false,
    };
  },
  mounted() {
    this.geBreadcrumbItems(this.$route);
  },
  created() {
    this.getNotice();
  },
  methods: {
    // 弹窗关闭
    close() {
      this.noticeShow = false;
    },
    geBreadcrumbItems(route) {
      // 获取当前页面的路由组
      this.breadcrumbItems = route.matched;
      // 从下标为1的位置开始获取路由，去除了最外层定义的根路由信息，并且获取到的数组里面只有meta数据，方便我们取值
      this.breadcrumbItems = this.breadcrumbItems
        .map((item) => item.meta)
        .splice(1);
      // 判断当前页面是否已经是首页
      let nowPath = route.path;
      // 如果当前页面不是首页，则在面包屑的首位置添加一个首页链接
      if (nowPath !== "/home") {
        this.breadcrumbItems.unshift();
      }
    },
    // 退出登录
    quit() {
      localStorage.removeItem("userinfo");
      // this.$router.push('/login')
      this.$router.go();
    },
    // 获取通知数量
    getNotice() {
      let data = {
        page: this.page,
        limit: this.limit,
        op: JSON.stringify({
          // cname: "LIKE %...%",
          isread: "IN(...)",
        }),
        filter: JSON.stringify({
          // cname: this.searchText,
          isread: 0,
        }),
      };
      let userInfo = localStorage.getItem("userinfo");
      if (!userInfo) {
        return;
      }
      this.$http.post("/api/notice/index", data).then((res) => {
        if (res.data.code == 1) {
          this.total = res.data.data.total;
        } else {
          return;
        }
      });
    },
    // 通知按钮点击
    noticeClick() {
      this.noticeShow = true;
      console.log("点击了东西");
    },
  },
  watch: {
    $route: function (newVal) {
      this.geBreadcrumbItems(newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/HeaderNav.vue